import * as React from "react";
import { forwardRef } from "react";
const SvgWarningCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	height: "1em",
	viewBox: "0 0 16 16",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("g", {
	fill: "none",
	fillRule: "evenodd",
	id: "Icons with numbers",
	stroke: "none",
	strokeWidth: 1
}, /* @__PURE__ */ React.createElement("g", { transform: "translate(-96.000000, -432.000000)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M103,443 L103,445 L105,445 L105,443 Z M104,448 C99.5817218,448 96,444.418278 96,440 C96,435.581722 99.5817218,432 104,432 C108.418278,432 112,435.581722 112,440 C112,444.418278 108.418278,448 104,448 Z M103,435 L103,442 L105,442 L105,435 Z M103,435",
	fill: "currentColor"
}))));
const ForwardRef = forwardRef(SvgWarningCircle);
export default ForwardRef;
